import { observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Container, Text } from 'telia-front-react';
import MovieRentalCatalogStore, { ContentType, MovieCategoriesParams } from '../stores/movierental/MovieRentalCatalogStore';
import RouteStore from '../stores/RouteStore';
import MovieRentalCatalog from './MovieRentalCatalog';
import TvCategories from './TvCategories';

export interface MovieRentalProps {
  rootCategoryId: string;
  rowsPerPage?: number;
  type?: ContentType;
  vodType?: string;
  packetIds?: string[];
  isFreeOfCharge?: boolean;
  specialPricePacketIds?: number[];
  defaultCategoryId?: string;
  applicationId?: string;
  movieRentalCatalogStore?: MovieRentalCatalogStore;
  routeStore?: RouteStore;
}

@observer
class MovieRental extends React.Component<MovieRentalProps> {
  @observable accessor selectedCategory: string = this.props.rootCategoryId;

  public async componentDidMount() {
    await this.props.movieRentalCatalogStore.loadMovieCategories(this.getMovieCategoriesParams());

    if (this.props.defaultCategoryId && this.categoryExists(this.props.defaultCategoryId)) {
      this.selectedCategory = this.props.defaultCategoryId;
    }
    this.setSelectedCategoryFromPath();
  }

  private categoryExists(categoryId: string) {
    return !!this.props.movieRentalCatalogStore.getCategories(this.getMovieCategoriesParams()).find((category) => Number(category.id) === Number(categoryId));
  }

  private setSelectedCategoryFromPath() {
    const categoryId = this.props.routeStore.decodedParams.movieRentalCategoryId;
    if (categoryId && this.categoryExists(categoryId)) {
      this.selectedCategory = categoryId;
    }
  }

  private getMovieCategoriesParams(): MovieCategoriesParams {
    const { rootCategoryId, type, vodType, packetIds, applicationId } = this.props;
    return {
      rootCategoryId,
      type: type || ContentType.ASSETS,
      vodType,
      packetIds,
      applicationId
    };
  }

  public render() {
    const { rootCategoryId, type, vodType, rowsPerPage, isFreeOfCharge, packetIds, specialPricePacketIds, applicationId } = this.props;
    return (
      <Container>
        <Text className="text-center">
          <TvCategories
            {...this.props}
            categoryId={this.selectedCategory}
            onCategoryChange={(category: string) => (this.selectedCategory = category)}
            spinner={true}
          />
          <MovieRentalCatalog
            key={this.selectedCategory}
            selectedCategoryId={this.selectedCategory}
            {...{
              rootCategoryId,
              type,
              vodType,
              rowsPerPage,
              isFreeOfCharge,
              packetIds,
              specialPricePacketIds,
              applicationId
            }}
          />
        </Text>
      </Container>
    );
  }
}

export default inject('movieRentalCatalogStore', 'routeStore')(MovieRental);
